export const tableColumnConfigMixin = {
  methods: {
    async loadTableColumnConfig () {
      if (!this.tableColumnConfigKey || !this.user?.token) return
      try {
        const { data } = await this.axios.get(
          `/api/table-column-config/${this.tableColumnConfigKey}`,
          { headers: { Authorization: 'Bearer ' + this.user.token } }
        )
        this.columnConfig = data
      } catch (e) {
        this.columnConfig = null
      }
    },
    async saveTableColumnConfig (tableKey, payload) {
      if (!tableKey || !this.user?.token) return
      try {
        const { data } = await this.axios.put(
          `/api/table-column-config/${tableKey}`,
          payload,
          { headers: { Authorization: 'Bearer ' + this.user.token } }
        )
        this.columnConfig = data
        return data
      } catch (e) {
        if (this.$store && this.$store.dispatch) {
          this.$store.dispatch('setError', { errorMsg: e.message || 'Failed to save column settings' })
        }
      }
    },
    buildTableColumnConfigList (defaultHeaders, config) {
      const byValue = new Map()
      if (config?.columns?.length) {
        config.columns.forEach(c => { byValue.set(c.value, { order: c.order, visible: c.visible !== false }) })
      }
      return defaultHeaders.map((h, index) => {
        const saved = byValue.get(h.value)
        return {
          ...h,
          order: saved != null ? saved.order : index,
          visible: saved != null ? saved.visible : true
        }
      }).sort((a, b) => a.order - b.order)
    },
    applyTableColumnConfig (defaultHeaders) {
      const config = this.columnConfig
      if (!config?.columns?.length) return defaultHeaders
      const byValue = new Map(defaultHeaders.map((h, i) => [h.value, { ...h, order: i }]))
      const ordered = config.columns
        .filter(c => c.visible !== false && byValue.has(c.value))
        .sort((a, b) => a.order - b.order)
        .map(c => byValue.get(c.value))
      return ordered.length ? ordered : defaultHeaders
    },
    buildTableColumnConfigPayload (columnList) {
      return {
        columns: columnList.map((c, index) => ({
          value: c.value,
          order: index,
          visible: c.visible !== false
        }))
      }
    }
  }
}
